/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 217);
/******/ })
/************************************************************************/
/******/ ({

/***/ 217:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./frontend/base/rsya.js
function createBlock(blockId) {
  var $block = $('<div></div>');
  $block.append("<div id=\"yandex_rtb_".concat(blockId, "\"></div>"));
  $block.append("<script type=\"text/javascript\">\n        (function(w, d, n, s, t) {\n            w[n] = w[n] || [];\n            w[n].push(function() {\n                Ya.Context.AdvManager.render({\n                    blockId: \"".concat(blockId, "\",\n                    renderTo: \"yandex_rtb_").concat(blockId, "\",\n                    async: true\n                });\n            });\n            t = d.getElementsByTagName(\"script\")[0];\n            s = d.createElement(\"script\");\n            s.type = \"text/javascript\";\n            s.src = \"//an.yandex.ru/system/context.js\";\n            s.async = true;\n            t.parentNode.insertBefore(s, t);\n        })(this, this.document, \"yandexContextAsyncCallbacks\");\n    </script>"));
  return $block;
}
// CONCATENATED MODULE: ./frontend/fixed_sidebar.js

jQuery(document).ready(function ($) {
  var MQL = 1023,
      SHOW_UPDOWN = 900,
      $window = $(window),
      $sidebar = $('.sidebar-content'),
      $sidebarEnd = $('.sidebar__end');

  if ($window.width() > MQL) {
    var blockId = 'R-A-270753-15';
    var $block = createBlock(blockId);

    var _$window = $(window);

    $sidebar.html($block.html());

    _$window.on('scroll', function () {
      var bottomView = $(window).scrollTop() + $(window).height(),
          topEnd = $sidebarEnd.offset().top;

      if (bottomView > topEnd) {
        $sidebar.removeClass('sidebar-content--fixed');
      } else {
        $sidebar.addClass('sidebar-content--fixed');
      }
    });
  }
});

/***/ })

/******/ });